// extracted by mini-css-extract-plugin
export default {"root":"ykXqYxxKmP8yfNcjVR3P","root--full-width":"V1miZVAG5YCh2GUVD2QA"};